import msgViewerComponent from './msg-viewer.component';

const msgViewerModule = angular.module('msgViewer', [
])
  .component('msgViewer', msgViewerComponent)
  .name;

export default msgViewerModule;
